require("dotenv").config();
var axios = require('axios')
const AUTH = 'Bearer keyvxqw6eWkYK0dB1'

export async function fetchData(){
    var config1 = {
        method: 'get',
        url: 'https://api.airtable.com/v0/appkgTkq8U4faXIsk/Work?view=Grid%20view',
        headers: { 
            'Authorization': AUTH,
        }
    };

    var config2 = {
        method: 'get',
        url: 'https://api.airtable.com/v0/appkgTkq8U4faXIsk/Project?view=Grid%20view',
        headers: { 
            'Authorization': AUTH,
        }
    };

    const work = await axios(config1) 
    .then(response => {
        return response.data.records.map(res => {
            const result = {
                Id: res.fields.Id,
                Company: res.fields.Company,
                Location: res.fields.Location,
                Role:  res.fields.Role,
                Duration:  res.fields.Duration,
                Activity:  res.fields.Activity.split('. '),
            }
            return result
        })
    })

    const project = await axios(config2) 
    .then(response => {
        return response.data.records.map(res => {
            const result = {
                Id: res.fields.Id,
                Title: res.fields.Title,
                Link: res.fields.Link,
                Description:  res.fields.Description,
                Repo:  res.fields.Repo,
                Tech: res.fields.Tech.split(', ')
            }
            return result
        })
    })

    saveData(project, work)
}

function saveData(project, work){
    const Portfolio = {}
    Portfolio.Project = project
    Portfolio.Work = work

    window.localStorage.setItem('Portfolio', JSON.stringify(Portfolio));
}

export async function porfolioData(){
    await fetchData()

    const Portfolio = JSON.parse(window.localStorage.getItem('Portfolio'));

    return Portfolio
}